export const getSharesInPercentage = (count: number, totalCount: number) => Math.round((count / totalCount) * 100)
